import {Link} from "react-router-dom";
import Icon from "../../components/selfcare/Icon.tsx";
import {SVGProps} from "react";
import {imageMap} from "../../images/imageMap.ts";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import Routing from "../../Routing.ts";
import ScrollToTop from "../../components/ScrollToTop.tsx";
import IconConditionsPrivacy from "../../components/icons/IconConditionsPrivacy.tsx";
import IconConditions from "../../components/icons/IconConditions.tsx";
import IconPress from "../../components/icons/IconPress.tsx";
import IconJobs from "../../components/icons/IconJobs.tsx";
import IconFirstPrize from "../../components/icons/IconFirstPrize.tsx";

const menuItems: {
    link: string,
    icon: (props: SVGProps<SVGSVGElement>) => JSX.Element,
    headline: string,
    noReact?: boolean,
}[] = [
    {
        link: Routing.About.Trustpilot,
        icon: IconFirstPrize,
        headline: "Trustpilot",
    },
    {
        link: Routing.About.Jobs.Index,
        icon: IconJobs,
        headline: "Ledige jobs",
    },
    {
        link: Routing.About.Press,
        icon: IconPress,
        headline: "Presse",
    },
    {
        link: Routing.About.Conditions,
        icon: IconConditions,
        headline: "Aftalevilkår",
    },
    {
        link: "/persondata",
        icon: IconConditionsPrivacy,
        headline: "Persondatameddelelse",
        noReact: true,
    },
]

export default function AboutPage() {
    setTitleAndMetaDescription("Om Hiper", "Læs mere om Hiper og hvem vi er. Vi sælger bredbånd og fibernet i hele Danmark og &ndash; du kan få op til 1.000 Mbit lynhurtigt internet.")
    useDatalayer()
    ScrollToTop()

    return (
        <section>
            <div className="content content--wide">
                <div className="blurb">
                    <h1 className="heading heading--big">Om Hiper</h1>
                </div>
                <div className="menugrid">
                    {menuItems.map((item, index) => {
                        if (item.noReact) {
                            return (
                                <a key={index} className="item" href={item.link}>
                                    <Icon component={item.icon}/>
                                    <h2 className="headline heading--smaller">{item.headline}</h2>
                                </a>
                            );
                        }
                        return (
                            <Link key={index} className="item" to={item.link}>
                                <Icon component={item.icon}/>
                                <h2 className="headline heading--smaller">{item.headline}</h2>
                            </Link>
                        );
                    })}
                </div>
                <article className="content about-us">
                    <h2 className="heading heading--medium">Vi er <span className="hiper-text-stroke">kun</span> gode til internet</h2>
                    <p>Lige siden vi startede Hiper, har vi været drevet af at forandre og konkurrere. Vi er målrettet og stålsatte på at levere det, vi er gode til: det hurtigst tænkelige internet til den lavest mulige pris. </p>
                    <p>Selvom produktet er enkelt, så kræver det fokus at få det til at fungere til perfektion. Hver dag øver vi os på at vores net bliver hurtigere, mere stabilt &ndash; bare bedre. Men stræber også efter at levere en god og kompetent service, når behovet opstår.</p>
                    <p>Èn enkelt ydelse med maksimalt udbytte for vores kunder. Det er det, vi lever og ånder for hos Hiper.</p>
                    <h2 className="heading heading--small">Hvad kan vi gøre for dig?</h2>
                    <p>Hos Hiper skaber vi de bedste rammer for vores kunder. Hos os får du alt den hastighed du har behov for, til at streame, arbejde og blive underholdt, lige når det passer dig. Samtidig får du et rent produkt &ndash; uden medfølgende fyld og produkter, som man alligevel aldrig får brugt fuldt ud.</p>
                    <p>Vi leverer kun <a href="/"> internet</a> og vi er gode til det!</p>
                    <p>Velkommen til Hiper!</p>
                    <div className="flex flex-center">
                        <Link
                            className="button blue"
                            to="/hjaelp/internet-og-wifi/hvordan-traekker-jeg-1000-mbit"
                        >
                            Læs mere om hastighed her
                        </Link>
                    </div>
                    <section className="loyalty-groups">
                        <div className="id-anchor" id="loyalty-groups"></div>
                        <h2 className="heading heading--medium">
                            <span className="hiper-text-stroke">Mest</span> værdi for pengene
                        </h2>
                        <h3 className="heading heading--smaller">
                            Hiper er blevet kåret til den Internetudbyder, der for 6. år i træk giver kunderne mest værdi for pengene.
                        </h3>
                        <p>
                            Igen i år har danskerne valgt Hiper som den internetleverandør, der giver <strong>&lsquo;Mest værdi for pengene&rsquo;</strong>
                            &ndash; og det er vi utrolige stolte af. Vi er ikke i tvivl om, at det skyldes vores dygtige medarbejdere, som hver dag knokler for at sikre,
                            at alle vores kunder får mest mulig værdi for deres penge.
                        </p>
                        <p>
                            Analyseinstituttet Loyalty Group har for femte år i træk offentliggjort BrancheIndexet for Internet, som dækker over danskernes tilfredshed
                            og loyalitet over for de forskellige internetudbydere på markedet. Undersøgelsen er din garanti for, at Hiper har den bedste internetløsning
                            på markedet &ndash; målt på både produkt- og servicekvalitet.
                        </p>
                        <div className="stamp">
                            <img src={imageMap.home.mvfp_2025} alt="Vinder Mest Værdi for Pengene 2025"/>
                        </div>

                        <h3 className="heading heading--small">
                            Højeste Net promoter score &ndash; &lsquo;Flest vil anbefale&rsquo; Hiper
                        </h3>
                        <p>
                            I både 2022, 2023 og 2025 har Hiper vundet <strong>&lsquo;Flest vil anbefale&rsquo;</strong>.
                            Net promoter score eller NPS® er et strategisk styringsværktøj,
                            baseret på kundernes svar på et enkelt spørgsmål: &ldquo;Vil du anbefale Hiper til familie, venner eller bekendte?&rdquo;.
                            Undersøgelsen er lavet af <a
                                href="https://loyaltygroup.dk/"
                                target="_blank"
                            >Loyalty Group</a>.
                        </p>
                        <div className="stamp stamp--multiple">
                            <img src={imageMap.home.nps_2022} alt="Vinder Flest Vil Anbefale 2022"/>
                            <img src={imageMap.home.nps_2023} alt="Vinder Flest Vil Anbefale 2023"/>
                        </div>
                        <h3 className="heading heading--small">
                            Om Loyalty Groups BrancheIndex
                        </h3>
                        <p>
                            Loyalty Group har mere end 25 års erfaring med at analysere og udvikle kundeloyalitet i stort set alle danske brancher.
                            Det gør dem til Skandinaviens førende konsulenthus inden for loyalitets udvikling.
                            Læs mere om Loyalty Group <a href="https://loyaltygroup.dk/" target="_blank">her</a>.
                        </p>
                    </section>
                </article>
            </div>
        </section>
    )
}
